"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var styles_1 = require("./styles");
var AXSDatePicker = function (_a) {
    var amountOfPickers = _a.amountOfPickers, onDateSelected = _a.onDateSelected, range = _a.range, navColor = _a.navColor, datePickerBackgroundColor = _a.datePickerBackgroundColor, dateColor = _a.dateColor, selectedDateColor = _a.selectedDateColor, selectedDateBackgroundColor = _a.selectedDateBackgroundColor, weekColor = _a.weekColor, rangeBackgroundColor = _a.rangeBackgroundColor, datePickerBorderColor = _a.datePickerBorderColor;
    var _b = React.useState(moment_1.default()), currentDate = _b[0], setCurrentDate = _b[1];
    var _c = React.useState(range), selectedDays = _c[0], setSelectedDays = _c[1];
    var wasDaySelected = function (chosenDay) {
        var isDayTheSame = function (day) { return moment_1.default(day).isSame(chosenDay, 'day'); };
        return !!selectedDays.find(isDayTheSame);
    };
    React.useEffect(function () {
        if (selectedDays.length === 1) {
            var endOfTheDay = moment_1.default(selectedDays[0]).endOf('day');
            return onDateSelected(__spreadArrays(selectedDays, [endOfTheDay]));
        }
        onDateSelected(__spreadArrays(selectedDays));
    }, [selectedDays]);
    var handleSelectDay = function (chosenDay) {
        var daySelected = wasDaySelected(chosenDay);
        if (daySelected && selectedDays.length === 2) {
            var updatedSelection = selectedDays.filter(function (day) { return !moment_1.default(day).isSame(chosenDay, 'day'); });
            return setSelectedDays(__spreadArrays(updatedSelection));
        }
        if (selectedDays.length < 2) {
            var chosenDays = __spreadArrays(selectedDays, [chosenDay]).sort(function (firstDay, secondDay) { return firstDay.diff(secondDay); });
            return setSelectedDays(chosenDays);
        }
        clearRange();
        return setSelectedDays([chosenDay]);
    };
    var getHeader = function (currentMonth) { return (React.createElement(styles_1.DateHeader, { color: weekColor }, moment_1.default(currentMonth).format('MMM YYYY'))); };
    var getDaysOfWeek = function () {
        var daysOfWeek = moment_1.default.weekdaysMin();
        return (React.createElement(AXSFlex_1.default, { justifyContent: "center" }, daysOfWeek.map(createWeekDayNameCell)));
    };
    var getDaysOfMonth = function (currentMonth) {
        var monthStartDay = moment_1.default(currentMonth).startOf('month');
        var monthEndDay = moment_1.default(currentMonth).endOf('month');
        var startDay = moment_1.default(monthStartDay).startOf('week');
        var endDay = moment_1.default(monthEndDay).endOf('week');
        var day = startDay;
        var days = [];
        var rows = [];
        var rowIndex = 0;
        while (day <= endDay) {
            for (var i = 0; i < 7; i += 1) {
                var calendarDay = day;
                var isSameMonth = moment_1.default(calendarDay).isSame(currentMonth, 'month');
                days.push(createDayCell(isSameMonth, calendarDay));
                day = moment_1.default(day).add(1, 'day');
            }
            rows.push((React.createElement(AXSFlex_1.default, { justifyContent: "center", key: "row-" + rowIndex, marginBottom: "10px" }, days)));
            rowIndex = rowIndex + 1;
            days = [];
        }
        return (React.createElement(AXSFlex_1.default, { justifyContent: "center", flexDirection: "column" }, rows));
    };
    var createDayCell = function (isSameMonth, calendarDay) {
        var formattedDay = calendarDay.format('D');
        var formattedDate = calendarDay.format('MM-DD-YYYY');
        var isStartDay = moment_1.default(calendarDay).isSame(selectedDays[0], 'day');
        var isEndDay = moment_1.default(calendarDay).isSame(selectedDays[1], 'day');
        var isDayInRange = selectedDays.length === 2
            && moment_1.default(calendarDay).isBetween(selectedDays[0], selectedDays[1]);
        var dayCellClassName = classnames_1.default([{
                'day-end': wasDaySelected(calendarDay) && isEndDay,
                'day-hidden': !isSameMonth,
                'day-in-range': isDayInRange,
                'day-range-active': selectedDays.length === 2,
                'day-start': wasDaySelected(calendarDay) && isStartDay,
            },
        ]);
        return (React.createElement(styles_1.DayCell, { className: dayCellClassName, color: dateColor, justifyContent: "center", key: "day-" + formattedDate, onClick: function () { return handleSelectDay(calendarDay); }, selectedDateColor: selectedDateColor, selectedDateBackgroundColor: selectedDateBackgroundColor, rangeBackgroundColor: rangeBackgroundColor },
            React.createElement(AXSFlex_1.default, { alignItems: "center", justifyContent: "center" }, formattedDay)));
    };
    var createWeekDayNameCell = function (day) {
        return (React.createElement(styles_1.WeekdayNameCell, { color: weekColor, justifyContent: "center", key: "weekday-" + day },
            React.createElement(AXSFlex_1.default, { alignItems: "center", justifyContent: "center" }, day)));
    };
    var setNextMonth = function () {
        var nextMonth = moment_1.default(currentDate).add(1, 'month');
        return setCurrentDate(nextMonth);
    };
    var setPrevMonth = function () {
        var prevMonth = moment_1.default(currentDate).subtract(1, 'month');
        return setCurrentDate(prevMonth);
    };
    var clearRange = function () { return setSelectedDays([]); };
    var renderDatePickers = function () {
        var datePickers = [];
        for (var picker = 0; picker < amountOfPickers; picker += 1) {
            var currentMonth = picker
                ? moment_1.default(currentDate).add(picker, 'month')
                : currentDate;
            var datePicker = (React.createElement(AXSFlexItem_1.default, { width: "338px", key: "date-picker-" + currentMonth },
                getHeader(currentMonth),
                getDaysOfWeek(),
                getDaysOfMonth(currentMonth)));
            datePickers = __spreadArrays(datePickers, [datePicker]);
        }
        return datePickers;
    };
    return (React.createElement(styles_1.DatePickerContainer, { datePickerBorderColor: datePickerBorderColor, backgroundColor: datePickerBackgroundColor },
        React.createElement(styles_1.PrevArrowButton, { color: navColor, name: "chevron-left", onClick: setPrevMonth }),
        React.createElement(AXSFlex_1.default, { justifyContent: "space-between" }, renderDatePickers()),
        React.createElement(styles_1.NextArrowButton, { color: navColor, name: "chevron-right", onClick: setNextMonth })));
};
AXSDatePicker.defaultProps = {
    amountOfPickers: 2,
    dateColor: 'axsui.components.datePicker.dateColor',
    datePickerBackgroundColor: 'axsui.components.datePicker.datePickerBackgroundColor',
    datePickerBorderColor: 'axsui.components.datePicker.datePickerBorderColor',
    monthColor: 'axsui.components.datePicker.monthColor',
    navColor: 'axsui.components.datePicker.navColor',
    rangeBackgroundColor: 'axsui.components.datePicker.rangeBackgroundColor',
    selectedDateBackgroundColor: 'axsui.components.datePicker.selectedDateBackgroundColor',
    selectedDateColor: 'axsui.components.datePicker.selectedDateColor',
    setRangeBtnLabel: 'Set Range',
    weekColor: 'axsui.components.datePicker.weekColor',
};
exports.default = AXSDatePicker;
//# sourceMappingURL=index.js.map